<template>
    <b-modal ref="teamSettingsModal" hide-footer title-class="text-center" body-class="p-0" centered @hide="hide();" @close="btnSfx">
        <template #modal-title>
            <b v-if="teamUser != undefined">{{ teamUser.username }}</b>
            <div class="small">{{ $t("team.role_"+teamRole.toLowerCase()) }}</div>
        </template>
        <b-list-group>
            <b-list-group-item @click="leaveOrKickOut(); btnSfx();" variant="light" size="lg" button>
                <b>{{ $t('team.member_options_popup_kick_out'+(isMe ? '_me' : '')) }}</b>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../../api'

const SettingsPopup = Vue.component('team-settings-popup', {
    data() {
        return {
            teamUser: undefined,
            teamRole: "",
            isMe: false,
        }
    },
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(user, teamRole) {
            this.isMe = user == undefined;
            this.teamUser = user == undefined ? this.$store.state.auth.user : user;
            this.teamRole = teamRole == undefined ? this.teamUser.teamRole : teamRole;

            this.$refs.teamSettingsModal.show();
        },

        hide() {
            this.$refs.teamSettingsModal.hide();
        }, 

        leaveOrKickOut(){
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.$t('team.member_options_kickout_popup_text'+(this.isMe ? '_me' : '')), {
                title: this.$t('team.member_options_kickout_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_yes'),
                cancelTitle: this.$t('base.btn_no'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    let req = $this.isMe ? api.teamLeave() : api.teamKickOut($this.teamUser.id);
                    req.then(function (response) {
                        $this.hide();
                        $this.$store.dispatch('auth/getMe');
                        if(!$this.isMe) 
                            $this.$emit('updateMembers');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
    },
})

export default SettingsPopup
</script>